import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/ContractBasis/LaneFees.requests'
import {
    LaneFeesDetail,
} from 'app/Apps/Pricing/Pricing.types'

export default (id) => {
    return useRequest<LaneFeesDetail>({
        key: RequestKeys.getContractBasisLaneFeeDetails,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.getLaneFee),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}
